module.exports = __webpack_public_path__ + "static/yd_byj-9b847838a8933c23d832e3564730573e.png";